module.exports = __webpack_public_path__ + "media/images/covid/icons/icon_area-f1df0aeafbbec7e788b9af0261747eb6.png";